import { trackEvent } from '../../../utils/analytics';
import type { AuthPromptMoment } from './authPrompt.types';
import { getAuthPromptConfig } from './authPromptMoments';

export type AuthPromptAnalyticsPayload = {
  moment: AuthPromptMoment;
  allowGuest: boolean;
  sourcePage: string;
  userStatus: 'guest' | 'logged_in' | 'unverified';
  authMethod?: 'google' | 'email' | 'guest';
};

export function trackAuthPromptShown(payload: AuthPromptAnalyticsPayload): void {
  trackEvent('auth.prompt.shown', payload);
}

export function trackAuthPromptSuccess(payload: AuthPromptAnalyticsPayload): void {
  trackEvent('auth.prompt.success', payload);
}

export function trackAuthPromptDismiss(payload: AuthPromptAnalyticsPayload): void {
  trackEvent('auth.prompt.dismiss', { ...payload, authMethod: 'guest' });
}

export function buildAuthPromptAnalyticsBase(
  moment: AuthPromptMoment,
  sourcePage: string,
  userStatus: AuthPromptAnalyticsPayload['userStatus'],
): Omit<AuthPromptAnalyticsPayload, 'authMethod'> {
  const config = getAuthPromptConfig(moment);
  return {
    moment,
    allowGuest: config.allowGuest,
    sourcePage,
    userStatus,
  };
}
